import request from '@/utils/ajax';

export function getMsgTplDetail(data){
  return request({
    url: `/manage/msgTemplate/info/${data.id}`,
    method: 'get',
  });
}

export function editMsgTpl(data){
  return request({
    url: `/wx/manage/msgTemplate/update`,
    method: 'post',
    data: data,
  });
}

export function deleteMsgTpl(data){
  return request({
    url: `/wx/manage/msgTemplate/delete`,
    method: 'post',
    data: data,
  });
}
